import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingDairyGrasslandFertiliser, setFootprintingDairyGrasslandFertiliserAdmin } from "services";

import { footprintingDairyPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_DAIRY_GRASSLAND_FERTILISER } from "consts";

import { FootprintingDairyGrasslandFertiliserPayload } from "models";

export const useMutateFootprintingDairyGrasslandFertiliser = (
  farmId: string,
  year: number,
  payload: FootprintingDairyGrasslandFertiliserPayload,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_GRASSLAND_FERTILISER, primaryDataId, isAdmin],
      mutationFn: () => (isAdmin ? setFootprintingDairyGrasslandFertiliserAdmin : setFootprintingDairyGrasslandFertiliser)(payload, primaryDataId ?? ""),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_DAIRY_GRASSLAND_FERTILISER, primaryDataId, isAdmin],
          ...footprintingDairyPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
